export const isTokenExpired = (tokenExpiry) => {
  return Date.now() >= tokenExpiry;
};
